import I18n from 'I18n';
import produce from 'immer';
import { EERIE } from 'HubStyleTokens/colors';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UINumberInput from 'UIComponents/input/UINumberInput';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import EnrollmentNotificationSettingsHelpTooltip from 'automation-ui-canvas/components/settings/v2/EnrollmentNotificationSettingsHelpTooltip';
import UISelect from 'UIComponents/input/UISelect';
import { NotificationCadences } from 'automation-ui-canvas/constants/NotificationTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PERCENTAGE_INPUT_WIDTH = '60px';
const CADENCE_INPUT_WIDTH = '150px';
const CADENCE_SELECT_WIDTH = '100px';
const ManualEnrollmentConfig = ({
  notificationCadence,
  manualEnrollmentConfig,
  handleManualEnrollmentConfigChange,
  readOnly
}) => /*#__PURE__*/_jsxs(View, {
  marginInlineStart: "800",
  children: [/*#__PURE__*/_jsxs(Flex, {
    justifyContent: "space-between",
    alignItems: "center",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "settingsV2.enrollmentNotificationSetting.v2.checkCount"
      }), /*#__PURE__*/_jsx(UITooltip, {
        use: "longform",
        placement: "top",
        title: /*#__PURE__*/_jsx(EnrollmentNotificationSettingsHelpTooltip, {
          cadence: notificationCadence
        }),
        children: /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(UIIcon, {
            "data-test-id": "enrollment-notifications-settings-help",
            name: "info",
            color: EERIE,
            className: "m-left-1"
          })
        })
      })]
    }), /*#__PURE__*/_jsx(View, {
      inlineSize: CADENCE_INPUT_WIDTH,
      children: /*#__PURE__*/_jsx(Flex, {
        justifyContent: "end",
        alignItems: "center",
        children: /*#__PURE__*/_jsx(View, {
          inlineSize: CADENCE_SELECT_WIDTH,
          children: /*#__PURE__*/_jsx(UISelect, {
            value: notificationCadence,
            options: [{
              value: NotificationCadences.DAILY,
              text: I18n.text('settingsV2.enrollmentNotificationSetting.v2.cadenceOptions.DAILY')
            }, {
              value: NotificationCadences.WEEKLY,
              text: I18n.text('settingsV2.enrollmentNotificationSetting.v2.cadenceOptions.WEEKLY')
            }],
            onChange: ({
              target: {
                value
              }
            }) => {
              const updatedNotificationConfig = produce(manualEnrollmentConfig, draftNotificationConfig => {
                draftNotificationConfig.rule.notificationCadence = value;
              });
              handleManualEnrollmentConfigChange(updatedNotificationConfig);
            },
            readOnly: readOnly
          })
        })
      })
    })]
  }), /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "space-between",
    alignItems: "center",
    marginBlockStart: "200",
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "settingsV2.enrollmentNotificationSetting.v2.increasedAtLeast"
    }), /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "end",
      alignItems: "center",
      gap: "200",
      children: [/*#__PURE__*/_jsx(View, {
        inlineSize: PERCENTAGE_INPUT_WIDTH,
        children: /*#__PURE__*/_jsx(UINumberInput, {
          min: 0,
          max: 999999,
          "data-test-id": "platform-settings-notifications-increase-percent-selector",
          onChange: ({
            target: {
              value
            }
          }) => {
            const updatedNotificationConfig = produce(manualEnrollmentConfig, draftNotificationConfig => {
              draftNotificationConfig.rule.increaseThresholdPercentage = Number(value);
            });
            handleManualEnrollmentConfigChange(updatedNotificationConfig);
          },
          value: manualEnrollmentConfig.rule.increaseThresholdPercentage,
          readOnly: readOnly
        })
      }), /*#__PURE__*/_jsx("span", {
        children: "%"
      })]
    })]
  }), /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "space-between",
    alignItems: "center",
    marginBlockStart: "200",
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "settingsV2.enrollmentNotificationSetting.v2.decreasedAtLeast"
    }), /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "end",
      alignItems: "center",
      gap: "200",
      children: [/*#__PURE__*/_jsx(View, {
        inlineSize: PERCENTAGE_INPUT_WIDTH,
        children: /*#__PURE__*/_jsx(UINumberInput, {
          min: 0,
          max: 100,
          "data-test-id": "platform-settings-notifications-decrease-percent-selector",
          onChange: ({
            target: {
              value
            }
          }) => {
            const updatedNotificationConfig = produce(manualEnrollmentConfig, draftNotificationConfig => {
              draftNotificationConfig.rule.decreaseThresholdPercentage = Number(value);
            });
            handleManualEnrollmentConfigChange(updatedNotificationConfig);
          },
          value: manualEnrollmentConfig.rule.decreaseThresholdPercentage,
          readOnly: readOnly
        })
      }), /*#__PURE__*/_jsx("span", {
        children: "%"
      })]
    })]
  })]
});
export default ManualEnrollmentConfig;